// Mirrors utilities/roles.js on portal-back -- single source of truth for the
// partner-multiplatform role equivalences on the frontend.

export const PARTNER_LIKE_ROLES = ['partner', 'partner-multiplatform']

export const isPartnerLike = (roleName: string): boolean =>
  PARTNER_LIKE_ROLES.includes(roleName)

// Only partner-multiplatform gets the multiplatform (checkbox) package-creation UI --
// admin keeps the legacy single-product form.
export const isMultiplatformUI = (roleName: string): boolean =>
  roleName === 'partner-multiplatform'
